import React from 'react';
import { Box, FormControl, InputAdornment, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import PropTypes from 'prop-types';

const SearchField = ({
  placeholder,
  dataList,
  setDataList,
  withoutOther,
  serverSide = false,
  onServerSearch = () => {},
  debounceMs = 500,
  resetKey
}) => {
  const debounceRef = React.useRef();
  const [value, setValue] = React.useState('');

  // Clear the input whenever resetKey changes (e.g. drawer re-opens).
  React.useEffect(() => {
    setValue('');
  }, [resetKey]);

  const handleChange = e => {
    const value = e.target.value;
    setValue(value);

    // Debounce server-side search to avoid excessive requests.
    if (serverSide) {
      clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => onServerSearch(value), debounceMs);
      return;
    }

    if (value === '') {
      setDataList(dataList);
      return;
    }

    const regex = new RegExp(value, 'i');
    const filtered = dataList.filter(item => regex.test(item.label));

    if (filtered.length === 0) {
      if (!withoutOther) {
        setDataList([{ value: 'Lainnya', label: 'Lainnya' }]);
      } else {
        setDataList([]);
      }
    } else {
      setDataList(filtered);
    }
  };

  return (
    <Box style={{ width: '100%' }}>
      <FormControl style={{ width: '100%' }}>
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            )
          }}
          autoComplete="off"
          onChange={e => handleChange(e)}
          placeholder={placeholder}
          value={value}
          variant="outlined"
        />
      </FormControl>
    </Box>
  );
};

SearchField.propTypes = {
  dataList: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ),
  debounceMs: PropTypes.number,
  onServerSearch: PropTypes.func,
  placeholder: PropTypes.string,
  resetKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ]),
  serverSide: PropTypes.bool,
  setDataList: PropTypes.func.isRequired,
  withoutOther: PropTypes.bool
};

export default SearchField;
